<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<clipPath id="clip-path-otherrrs">
				<rect
					id="Rectangle_15504"
					data-name="Rectangle 15504"
					width="20"
					height="20"
					transform="translate(429 883)"
					fill="#fff"
					stroke="#707070"
					stroke-width="1"
				/>
			</clipPath>
		</defs>
		<g id="Mask_Group_44955" data-name="Mask Group 44955" transform="translate(-429 -883)" clip-path="url(#clip-path-otherrrs)">
			<g id="Layer_1-2" transform="translate(429 883)">
				<circle id="Ellipse_935" data-name="Ellipse 935" cx="10" cy="10" r="10" fill="#fff" />
				<path id="Path_33052" data-name="Path 33052" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Z" fill="#969bae" />
				<path
					id="Path_32992"
					d="M15.74,4.26a1.557,1.557,0,0,0-2.19,0l-.68.68,2.19,2.19.68-.68A1.557,1.557,0,0,0,15.74,4.26Zm-1.31,3.5L12.24,5.57,5.07,12.74a3.121,3.121,0,0,0-.78,1.31l-.47,1.58a.441.441,0,0,0,.3.55.528.528,0,0,0,.25,0l1.58-.47a3.141,3.141,0,0,0,1.31-.78l7.17-7.17Z"
					fill="#fff"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'OtherSvg',
};
</script>
